// eslint-disable-next-line import/no-extraneous-dependencies
import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { typography, fontWeights } from '../../../styles/typography';

const types = {
  primary: {
    ...typography.effra14Link,
    fontWeight: fontWeights.medium,
    color: colorsPalette.white,
    background: colorsPalette.red,
    ':hover, :focus': {
      background: colorsPalette.red110,
      outlineColor: colorsPalette.red110,
    },
    ':disabled': {
      cursor: 'not-allowed',
      background: colorsPalette.grey20,
    },
  },
  secondary: {
    ...typography.effra14Link,
    fontWeight: fontWeights.medium,
    background: colorsPalette.transparent,
    ':disabled': {
      color: colorsPalette.grey20,
      cursor: 'not-allowed',
      outlineColor: colorsPalette.grey20,
    },
  },
  tertiary: {
    ...typography.effra14Link,
    color: colorsPalette.red,
    backgroundColor: colorsPalette.transparent,
    span: {
      borderBottom: `1px solid ${colorsPalette.red20} `,
    },
  },
};

const themes = {
  light: {
    color: colorsPalette.black,
    outline: `1px solid ${colorsPalette.grey20}`,
    ':hover, :focus': {
      outlineColor: colorsPalette.grey40,
    },
  },
  dark: {
    color: colorsPalette.white,
    outline: `1px solid ${colorsPalette.grey80}`,
    ':hover, :focus': {
      outlineColor: colorsPalette.grey40,
    },
  },
};

const createButtonCss = (
  type = 'primary',
  options = {
    theme: 'light',
  },
) => css`
  align-items: center;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  height: 56px;
  min-width: 100px;
  outline: none;
  padding: 0 24px;
  text-align: center;
  text-decoration: none;
  width: 100%;
  ${types[type]}
  ${type === 'secondary' && themes[options.theme]}

  a {
    text-decoration: none;
    color: ${colorsPalette.white};
  }
`;

export default createButtonCss;
